/**
 * @author Carlos Fernando Herrera Guillen
 * @Copyright (c) Infotrack. All rights reserved.
 */
import ModeloEtiqueta from 'Infotrack@Modelos/smartStock/etiquetas';
import ModeloItem from 'Infotrack@Modelos/smartStock/items';
import ModeloImpresora from 'Infotrack@Modelos/smartStock/impresora';
import IFiltroImpresion from 'Infotrack@Modelos/smartStock/impresora/entidades/filtro';
import { InputEtiquetaItem } from '../interfaces';
import IEtiquetaItem from 'Infotrack@Modelos/smartStock/items/entidades/IEtiquetaItem';
import notificacionGlobal from '@infotrack/presentacion-componentes/notificacionGlobal';

export default class EntidadesFiltroInvenitarioCM {
    private modeloEtiqueta: ModeloEtiqueta;
    private modeloItem: ModeloItem;
    private modeloImpresora: ModeloImpresora;

    constructor() {
        this.modeloEtiqueta = new ModeloEtiqueta();
        this.modeloItem = new ModeloItem();
        this.modeloImpresora = new ModeloImpresora();
    }

    public async consultaEntidadesImpresion() {
        const respuestaEtiquetas = await this.modeloEtiqueta.consultarEtiquetas();
        const respuestaImpresion = await this.modeloImpresora.consultarImpresoras();

        return {
            etiquetas: respuestaEtiquetas.data.Entidades,
            impresoras: respuestaImpresion.data.Entidades,
        };
    }

    public async consultaItemsEtiqueta(idEtiqueta: string) {
        const respuesta = await Promise.all([this.modeloItem.consultarItemsMiddleware(idEtiqueta)]);
        return respuesta[0].data.Entidades;
    }

    public async consultaItemsEtiquetaTabla(filtro: IFiltroImpresion) {
        let etiquetaItems: InputEtiquetaItem[] = [];
        if (this.validarEntidadFiltro(filtro)) {
            const respuesta = await Promise.all([this.modeloItem.consultarItemsEtiquetaMiddleware(filtro)]);
            respuesta[0].data.Entidades.map((r) => {
                etiquetaItems.push({
                    Clasificacion: r.Clasificacion,
                    CantidadCopias: r.CantidadCopias,
                    Imprimir: false,
                    FechaIngreso: r.FechaIngreso,
                    FechaVencimiento: r.FechaVencimiento,
                    CantidadSaldo: r.CantidadSaldo,
                    CodigoEmpresaItem: r.CodigoEmpresaItem,
                    FamiliaDescripcion: r.FamiliaDescripcion,
                    Importacion: r.Importacion,
                    ItemDescripcion: r.ItemDescripcion,
                    ItemId: r.ItemId,
                    ItemIDCodEmpaque: r.ItemIDCodEmpaque,
                    Lote: r.Lote,
                    Manifiesto: r.Manifiesto,
                    Movimientoid: r.Movimientoid,
                    Peso: r.Peso,
                    Serial: r.Serial,
                    UnidadDescripcion: r.UnidadDescripcion,
                });
                
            });
        }
        return etiquetaItems;
    }

    public async consultarItemsSinEtiqueta(idEmpresa: string, idsItem: number[]) {
        const respuesta = await Promise.all([this.modeloItem.consultarItemsSinEtiqueta(idEmpresa, idsItem)]);
        return respuesta[0].data.Entidades;
    }

    public async guardarItemsEtiqueta(etiquetaItems: IEtiquetaItem[]) {
        const respuesta = await Promise.all([this.modeloItem.guardarItemsEtiqueta(etiquetaItems)]);
        return respuesta[0].data;
    }

    public validarEntidadFiltro = (filtro: IFiltroImpresion) => {
        if (filtro.EtiquetaId === 0 ) {
            notificacionGlobal('comunes.alerta.camposIncompletos', 6000, 'warning', true);
            return false;
        }

        return true;
    };
}
